export class ConditionReportTransitionStateError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "ConditionReportTransitionStateError"
    }
}